import { TMProviderInvoiceItemAPI } from '@business/api/tm_provider_invoice_item';
import { PayablesInvoiceItemSearchParams, TMProviderInvoiceId, TMProviderInvoiceItemResponse, TMProviderInvoiceSearchParams } from '@business/entities/tm/TMProviderInvoiceResponse';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { ProviderInvoiceFormData } from '@modules/timeMaterials/TimeMaterialOverlay/ProviderInvoiceModal/ProviderInvoiceModal';
import { TMInvoiceScheduleFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/Order/AddEditTMInvoiceScheduleModal/AddEditTMInvoiceScheduleModal';
import { switchMap } from 'rxjs/operators';

export class TMProviderInvoiceItemBloc extends BaseBloc {
  private readonly typeRepo = new Repository<TMProviderInvoiceItemResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.typeRepo.items$;
  readonly selectItem = this.typeRepo.selectItem;

  onReset() {
    this.typeRepo.reset();
  }

  fetchInvoiceItems = (data?: PayablesInvoiceItemSearchParams) => {
    return TMProviderInvoiceItemAPI.fetchInvoiceItems(data).pipe(
      this.typeRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_invoice_schedule_error') }),
    );
  };

  fetchInvoiceItem = (id: TMProviderInvoiceId) => {
    return TMProviderInvoiceItemAPI.fetchInvoiceItem(id).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_invoice_schedule_error') }),
    );
  };

  createInvoiceItem = (data: TMInvoiceScheduleFormData) => {
    return TMProviderInvoiceItemAPI.createInvoiceItem(data).pipe(
      this.typeRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_invoice_schedule'),
      }),
    );
  };

  createInvoiceItems = (data: ProviderInvoiceFormData) => {
    return TMProviderInvoiceItemAPI.createInvoiceItems(data).pipe(
      this.typeRepo.ops.addMany(items => items),
      handleMessage({
        type: requestMessage('create_invoice_schedule'),
      }),
    );
  };

  updateInvoiceItem = (id: TMProviderInvoiceId, data: TMInvoiceScheduleFormData) => {
    return TMProviderInvoiceItemAPI.updateInvoiceItem(id, data).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_invoice_schedule'),
      }),
    );
  };

  deleteInvoiceItem = (id: TMProviderInvoiceId) => {
    return showDeleteConfirmation('Delete Inovice', 'Do you really want to remove this Inovice?').pipe(
      switchMap(() => TMProviderInvoiceItemAPI.deleteInvoiceItem(id)),
      this.typeRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_invoice_schedule'),
      }),
    );
  };
}
